import {
    mapActions,
    mapGetters,
    mapMutations,
} from 'vuex';
import ApercuPanier from '../../components/ApercuPanier/ApercuPanier.vue'
import CrossSellings from '../../components/CrossSellings/CrossSellings.vue'

export default {

    components: {
        ApercuPanier,
        CrossSellings
    },

    props: {},

    computed: {
        ...mapGetters([
            'article',
            'colors',
            'socle',
            'Ref_article',
            'cart',
            'priceHiddenMode',
            'articleLoading'
        ]),

        /**
         * Propriété returnant les options positionnées sur l'article.
         * @returns
         */
        options() {
            let options = ''
            if (this.article.Famille === 'PLA.' && this.colors.length > 0 && this.colors[0] != null && this.colors.find(el => el.value == this.couleur) != undefined) {
              options = options + ' - ' + this.colors.find(el => el.value == this.couleur).text
            }
            if (this.article.Famille === 'PLA.') {
                if (this.vinter === 0) {
                    options  = options + ' - SANS INTER'
                } else {
                    options = options + ' - ' + this.vinter + ' INTER'
                    if (this.vinter > 1) {
                        options = options + 'S'
                    }
                }
            }
            if (this.article.Famille === 'PLA.' && this.bron === 'Avec' && this.commentaireBronze !== '') {
                options = options + ' - ' + this.commentaireBronze
            }
            if (this.SocleChoose === true && !this.socleObligatoire && !this.articleLoading) {
                options = options + ' - SOCLE ' + this.socle.Code
            }
            return options
        },

        /**
         * Propriété retournant le nom complet de l'article.
         * @returns
         */
        nomComplet() {
            let nom = this.article.Nom + this.options
            return nom
        },



        prixUnitaire() {
            let prixUnitaire = 0
            const totalQuantiteSamePLRef = this.quantite + this.getQuantiteArticleSamePLRef(this.article.PL_Reference)
            // S'il existe des tarifs unitaire dégressifs.
            if (this.article.tarifs && this.article.tarifs.length > 0) {
                prixUnitaire = parseFloat(this.article.PrixBaseHT)
                this.article.tarifs.forEach(aTarif => {
                    // Si la quantité est inférieure à la borne, alors on récupère la valeur du tarif
                    // et on indique qu'il a été trouvé pour éviter de l'écraser lors d'une autre itération.
                    if (totalQuantiteSamePLRef <= parseFloat(aTarif.Borne)) {
                        prixUnitaire = parseFloat(aTarif.Valeur)
                    }
                })
            } else {
                // Sinon renvoie du prix unitaire
                prixUnitaire = parseFloat(this.article.PrixBaseHT)
            }
            return prixUnitaire.toFixed(2)
        },


        /**
         * Propriété indiquant à partir de quelle quantité le tarif dégressif est appliqué.
         * La plus petite des bornes du tableau "tarif" de l'article est récupérée.
         */
        limiteTarifDegressif() {
            let borne = 1000
            this.article.tarifs.forEach(aTarif => {
                if (parseFloat(aTarif.Borne) < borne) {
                    borne = parseFloat(aTarif.Borne)
                }
            })
            // Rajout de 1 à la borne : le tarif s'applique au delà de cette borne.
            return borne + 1
        },

        /**
         * Valeur permettant de savoir si l'option pied socle est accessible ou non.
         * @returns
         */
        piedSocleEnabled() {
            if (this.article.LG_RefSocle == "PIEDS" || this.article.LG_RefSocle == "SOCLE") {
                if (this.article.LG_MiroirSocle == '') {
                    if (this.article.LG_RefSocle == "PIEDS") {
                        this.sup = "Pieds"
                    } else {
                        this.sup = "Socle"
                        this.socleObligatoire = true;
                    }
                    return false
                } else {
                    if (this.article.LG_RefSocle == "PIEDS") {
                        this.sup = "Pieds"
                    } else {
                        this.sup = "Socle"
                    }
                    this.socleObligatoire = false
                    return true
                }
            } else {
                if (this.article.LG_PlusValue > 0) {
                    if (this.isFromCrossSellings) {
                        this.sup = "Pieds"
                    }
                    this.socleObligatoire = false
                    return true
                } else {
                    this.socleObligatoire = true
                    return false
                }
            }
        },

        /**
         * Propriété permettant de savoir si le max a été atteint.
         */
        isMaxReached() {
            let isReached = false
            if (this.article.PL_QuantiteMax && this.quantite >= this.article.PL_QuantiteMax) {
                isReached = true
            }
            return isReached
        }
    },

    data() {
        return {
            show: true,
            screenWidth: 1200,
            quantite: 0,
            borneTarifsSorted: [],
            couleur: 'Panachage',
            text: '',
            sup: 'Pieds',
            vinter: 0,
            bron: '',
            SocleChoose: false,
            PU_HT: 0.00,
            T_HT: 0.00,
            article_PU: 0.00,
            socle_PU: 0.00,
            socleObligatoire: false,
            multiplicateur: 0,
            productAddedToCart: false,
            articleLoaded: false,
            isFromChangementSupport: false,
            fromCommande: false,
            idCommande: '',
            commentaire: '',
            isFromCrossSellings: false,
            commentaireBronze: '',
            fromGetArticle: false,
            loaded: false,
            support: [{
                    text: 'Pieds',
                    value: 'Pieds'
                },
                {
                    text: 'Socle',
                    value: 'Socle'
                },
            ],
            inter: [{
                text: '0',
                value: 0
            }],
            bronze: [{
                    text: 'Sans',
                    value: 'Sans'
                },
                {
                    text: 'Avec',
                    value: 'Avec'
                }
            ],
            famille: ''
        };
    },

    watch: {
        // Gestion du support
        sup() {
            // Si le changement de support provient d'un choix depuis les boutons radios ET que le support est un socle.
            if (this.sup === 'Socle' && this.isFromChangementSupport) {
                if (this.article.LG_RefSocle === 'SOCLE') {
                    this.socle_PU = parseFloat(this.article.LG_PlusValue).toFixed(2);
                    this.PU_HT = this.article_PU + this.socle_PU;
                    this.PU_HT = parseFloat(this.PU_HT).toFixed(2);
                    this.TotalUpdate()
                    this.SocleChoose = true
                } else if (this.article.LG_RefSocle == "PIEDS") {
                    this.productAddedToCart = false
                    // this.quantite = 0
                    this.getArticle(this.formatCodeArticle(this.article.LG_MiroirSocle), true)
                } else {
                    this.getSocleByCode(this.article.LG_RefSocle).then(res => {
                        this.socle_PU = parseFloat(this.article.LG_PlusValue).toFixed(2);
                        this.PU_HT = this.article_PU + this.socle_PU;
                        this.PU_HT = parseFloat(this.PU_HT).toFixed(2);
                        this.TotalUpdate();
                        this.SocleChoose = true
                    });
                    if (!this.socleObligatoire) {
                        this.SocleChoose = true
                    }
                }
            } else if (this.sup == 'Pieds' && this.isFromChangementSupport) {
                // Si le changement de support provient d'un choix depuis les boutons radios ET que le support est un pieds.
                this.SocleChoose = false;
                this.TotalUpdate();
                this.PU_HT = 0;
                this.sup = 'Pieds'
                if (this.article.LG_RefSocle == "SOCLE") {
                    this.SocleChoose = false
                    this.getArticle(this.formatCodeArticle(this.article.LG_MiroirSocle))
                }
            }
            this.checkIfArticleWithSameConfigExist()
        },
        bron() {
            if (!this.fromGetArticle && this.bron != this.article.LG_Bronze) {
                this.getArticle(this.article.LG_Miroir)
                this.productAddedToCart = false
                // this.quantite = 0
            }
            this.fromGetArticle = false;
            this.checkIfArticleWithSameConfigExist()
        },
        couleur() {
            this.ChangeCouleur()
            this.checkIfArticleWithSameConfigExist()
        },
        quantite() {
            if (!this.quantite || this.quantite === '') {
                this.quantite = 0
            }
            this.quantite = parseFloat(this.quantite)
        },
        vinter() {
            this.checkIfArticleWithSameConfigExist()
        },
    },

    methods: {
        ...mapMutations([
            'setCart',
            'addArticle',
            'resetFiltres',
            'resetColors'
        ]),
        ...mapActions([
            'getColorByArticle',
            'getArticleByCode',
            'getSocleByCode',
            'getArticleByRef'
        ]),

        ValidateForm() {
            let idCommande = ''
            if (this.$route.params.idCommande && this.productAddedToCart) {
                idCommande = this.$route.params.idCommande
            } else if (this.productAddedToCart) {
                idCommande = this.idCommande
            } else {
                idCommande = Math.random().toString(36)
                this.idCommande = idCommande
            }
            let commande = {
                idCommande: idCommande,
                Code: this.article.Code,
                Nom: this.nomComplet,
                Quantite: this.quantite,
                PU: parseFloat(this.article_PU) + (this.SocleChoose ? parseFloat(this.socle_PU) : 0),
                PrixBaseHT: this.article.PrixBaseHT,
                PT: parseFloat(this.T_HT),
                Famille: this.article.Famille,
                Tarifs: this.article.tarifs,
                PLRef: this.article.PL_Reference,
                Commentaire: this.commentaire,
                CommentaireBronze: this.commentaireBronze,
                Options: this.options,
                socle_PU: this.socle_PU
            }
            if (this.article.PL_QuantiteMax) {
                commande.QuantiteMax = this.article.PL_QuantiteMax
            }
            commande.Couleur = this.couleur
            commande.SocleChoose = this.SocleChoose
            commande.sup = this.sup
            commande.vinter = this.vinter
            commande.bron = this.bron
            commande.text = this.text
            this.addArticle(commande);
            if (this.fromCommande) {
                this.notify('success', 'Modifié', 'Le produit a été modifié dans le panier')
            } else {
                this.notify('success', 'Ajouté', 'Le produit a été ajouté au panier')
                // RAZ des quantité et paramètres
                this.quantite = 0
                if (!this.socleObligatoire && this.famille == 'plaques') {
                    this.sup = 'Pieds'
                }
                if (parseInt(this.article.LG_NbInter) <= parseInt(this.article.PL_IntersMax)) {
                    this.vinter = parseInt(this.article.LG_NbInter)
                } else {
                    this.vinter = parseInt(this.article.PL_IntersMax)
                }
            }
        },

        TotalUpdate() {
            if (this.article.PL_QuantiteMax && this.quantite > parseInt(this.article.PL_QuantiteMax)) {
                this.quantite = parseInt(this.article.PL_QuantiteMax)
            }
            if (this.SocleChoose) {
                this.T_HT = ((parseFloat(this.prixUnitaire) + parseFloat(this.article.LG_PlusValue)) * parseInt(this.quantite)).toFixed(2);
            } else if (this.multiplicateur != 0) {
                this.T_HT = ((parseFloat(this.prixUnitaire) * parseInt(this.quantite)) * this.multiplicateur).toFixed(2);
            } else {
                this.T_HT = (parseFloat(this.prixUnitaire) * parseInt(this.quantite)).toFixed(2)
            }
        },

        /**
         * Fonction pour formatter le code article et enlever l'éventuel "/" en le remplaçant par "&".
         * @param {*} pCode
         * @returns
         */
        formatCodeArticle(pCode) {
            if (pCode.includes('/')) {
                pCode = pCode.replace('/', '$')
            }
            return pCode
        },

        /**
         * Fonction pour modifier le code article utilisé pour l'image. Remplacement de "/" par "-".
         * @param {*} pCode
         * @returns
         */
        formatCodeArticleForImage(pCode) {
            if (pCode) {
                if (pCode.includes('/')) {
                    pCode = pCode.replace('/', '-')
                }
                return pCode
            }
        },

        /**
         * Fonction permettant d'avoir le nombre d'article dans le panier avec la même PL_Ref passé en paramètre.
         * @param {*} plRef
         * @returns
         */
        getQuantiteArticleSamePLRef(plRef) {
            let total = 0
            this.cart.forEach(aItem => {
                if (aItem.PLRef && aItem.PLRef === plRef && aItem.Code !== this.article.Code) {
                    total = total + parseInt(aItem.Quantite)
                }
            })
            return total
        },

        /**
         * Fonction pour changer d'article.
         * @param {*} codeF
         */
        ChangeArticle(codeF) {
            if (codeF !== this.article.Code) {
                this.productAddedToCart = false
                this.quantite = 0
            }
            this.SocleChoose = false;
            this.commentaire = '';
            this.getArticleByCode(codeF).then(res => {
                this.article_PU = parseFloat(res.data.PrixBaseHT).toFixed(2)
                this.borneTarifsSorted = this.article.tarifs.sort(this.compare).reverse()
                this.checkIfArticleWithSameConfigExist()
            });
        },

        ChangeCouleur() {
            if (this.couleur.length > 1) {
                let col = this.couleur.replace('/', '$')
                this.ChangeArticle(col);
            }
        },

        /**
         * Fonction permettant de charger les informations de l'article.
         * @param {*} code Code de l'article.
         * @param {*} isFromCrossSellings Booléen permettant de savoir si le chargement provient du cross-sellings.
         */
        getArticle(code, isFromCrossSellings = false) {
            this.loaded = false;
            this.famille = this.$route.name;
            this.getArticleByCode(code).then(res => {
                this.commentaire = '';
                this.commentaireBronze = '';
                this.article_PU = parseFloat(this.article.PrixBaseHT).toFixed(2)
                // Récupération des éventuels tarifs multiples appliqués pour des tarifs dégréssifs.
                if (this.article.tarifs && this.article.tarifs.length > 0) {
                    // Récupération des bornes des tarifs triés
                    this.borneTarifsSorted = this.article.tarifs.sort(this.compare).reverse();
                }
                // Récupération des informations sur les inters.
                if (parseInt(this.article.LG_NbInter) <= parseInt(this.article.PL_IntersMax)) {
                    this.vinter = parseInt(this.article.LG_NbInter)
                } else {
                    this.vinter = parseInt(this.article.PL_IntersMax)
                }
                this.inter = [{
                    text: '0',
                    value: 0
                }];
                for (let i = 1; i <= parseInt(this.article.PL_IntersMax); i++) {
                    let ObInter = {
                        text: i,
                        value: i
                    }
                    this.inter.push(ObInter);
                }
                this.text = this.article.LG_Commentaire;
                this.bron = this.article.LG_Bronze;
                // Vérification de la présence ou non de l'article dans le panier si l'on provient de la page panier.
                if (this.$route.params.idCommande) {
                    this.cart.forEach(aItem => {
                        if (aItem.idCommande === this.$route.params.idCommande) {
                          this.quantite = aItem.Quantite
                            this.commentaire = aItem.Commentaire
                            this.commentaireBronze = aItem.CommentaireBronze
                            this.couleur = aItem.Couleur
                            this.SocleChoose = aItem.SocleChoose
                            this.sup = aItem.sup
                            this.vinter = aItem.vinter
                            // this.fromGetArticle = true;
                            this.bron = aItem.bron
                            this.text = aItem.text
                            this.fromCommande = true;
                        }
                    });
                    this.$route.params.idCommande = '';
                }
                if (this.famille == 'plaques' || this.famille == 'accessoires') {
                    this.resetColors()
                    this.isFromCrossSellings = isFromCrossSellings
                    // Récupération des couleurs
                    this.getColorByArticle(code).then(res => {
                        if (this.colors.length > 0 && this.colors[0] != null) {
                            // Récupération du nom de la couleur actuelle
                            let nomCouleur = ''
                            this.colors.forEach(aColor => {
                                if (aColor.value === this.couleur) {
                                    nomCouleur = aColor.text
                                }
                            })
                            // Si une couleur déja sélectionnée existe dans la liste des couleurs, on la sélectionne
                            let found = false
                            this.colors.forEach(aColor => {
                                if (aColor.text === nomCouleur) {
                                    this.couleur = aColor.value
                                    found = true
                                }
                            })
                            // Si non trouvé, on prend la première couleur
                            if (!found) {
                                this.couleur = this.colors[0].value
                            }
                            if (this.socleObligatoire && this.isFromCrossSellings) {
                                // Si le changement de support ne provient pas d'un choix depuis les boutons radios (initialisation) ET que le support est un socle.
                                this.getSocleByCode(this.article.LG_RefSocle).then(res => {
                                    this.socle_PU = parseFloat(this.article.LG_PlusValue).toFixed(2);
                                    this.PU_HT = this.article_PU + this.socle_PU;
                                    this.PU_HT = parseFloat(this.PU_HT).toFixed(2);
                                    this.TotalUpdate();
                                    this.SocleChoose = true
                                });
                            }
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                    this.loaded = true;
                  } else {
                    this.getArticleByRef(this.article.PL_Reference).then(res => {
                      this.checkIfArticleWithSameConfigExist()
                      this.loaded = true;
                    }).catch(err => {
                        console.log(err)
                    })
                }
                this.isFromChangementSupport = true
            }).catch(err => {
                this.loaded = true;
                console.log(err)
            })
        },

        QuantitePlus() {
            if (this.article.PL_QuantiteMax && this.quantite < this.article.PL_QuantiteMax) {
                this.quantite += 1;
            } else if (!this.article.PL_QuantiteMax) {
                this.quantite += 1;
            }
            this.TotalUpdate()
        },
        QuantiteMoins() {
            this.quantite -= 1
            if (this.quantite <= 0) {
                this.T_HT = 0;
                this.quantite = 0;
            } else {
                this.TotalUpdate();
            }
        },

        /**
         * Fonction pour retourner sur la page famille.
         */
        goToFamily() {
            this.$router.push({
                path: '/' + this.famille,
                query: {
                    origin: 'article',
                }
            }, )
        },

        /**
         * Fonction utilisée pour le trie des bornes dans les tarifs.
         * @param {*} a
         * @param {*} b
         * @returns
         */
        compare(a, b) {
            let aFloat = parseFloat(a.Borne)
            let bFloat = parseFloat(b.Borne)
            if (aFloat < bFloat) {
                return -1;
            }
            if (aFloat > bFloat) {
                return 1;
            }
            return 0;
        },

        /**
         * Fonction permettant de savoir si un article avec exactement la configuration existe déja dans le panier.
         * Si c'est le cas, alors on passe en mode édition.
         */
        checkIfArticleWithSameConfigExist() {
            let found = false
            let i = 0
            while (!found && this.cart.length > i) {
                let isTheSame = true
                // Code
                if (this.cart[i].Code !== this.article.Code) {
                    isTheSame = false
                }
                // Couleur
                if (this.cart[i].Couleur !== this.couleur) {
                    isTheSame = false
                }
                // Contrôle pour les plaques
                if (this.article.Famille === 'PLA.') {
                    // Bronze
                    if (this.bron !== this.cart[i].bron) {
                        isTheSame = false
                    }
                    // Support
                    if (this.sup !== this.cart[i].sup) {
                        isTheSame = false
                    }
                    // Inter
                    if (this.vinter !== this.cart[i].vinter) {
                        isTheSame = false
                    }
                    // Socle
                    if (this.SocleChoose !== this.cart[i].SocleChoose) {
                        isTheSame = false
                    }
                }
                if (isTheSame) {
                    found = true
                    // Si il s'agit du même, alors on indique que le produit est ajouté au panier
                    this.productAddedToCart = true
                    this.idCommande = this.cart[i].idCommande
                    // Récupération des informations
                    this.quantite = this.cart[i].Quantite
                    this.couleur = this.cart[i].Couleur
                    this.SocleChoose = this.cart[i].SocleChoose
                    this.sup = this.cart[i].sup
                    this.vinter = this.cart[i].vinter
                    this.bron = this.cart[i].bron
                    this.text = this.cart[i].text
                    this.commentaire = this.cart[i].Commentaire
                    this.commentaireBronze = this.cart[i].CommentaireBronze
                    this.fromCommande = true
                }
                i = i + 1
            }
            // S'il n'a pas été trouvé
            if (!found) {
                this.productAddedToCart = false
                this.fromCommande = false
                // this.quantite = 0
            }
            this.TotalUpdate()
        }
    },

    filters: {
        formatNumber: (pValue) => {
            return parseFloat(pValue).toLocaleString('fr-FR', {
                style: "currency",
                currency: "EUR"
            })
        },
    },


    mounted() {
        let code = this.$route.params.slugArticle
        window.addEventListener("resize", (e) => this.screenWidth = window.innerWidth);
        this.screenWidth = window.innerWidth;
        if (this.famille == 'inter') {
            this.multiplicateur = 5;
        }
        if (this.$route.params.idCommande) {
            this.productAddedToCart = true
        }
        const formattedCode = this.formatCodeArticle(code)
        // Chargement de l'article
        this.getArticle(formattedCode)
    },

    beforeRouteLeave(to, from, next) {
        next()
    }

};
